export default __webpack_public_path__ + "static/media/verifyerror.98cccd58.svg";